import ApiService from '@/common/api.service'

export default {
  getDecrypt (code, type) {
    return new Promise((resolve, reject) => {
      ApiService.query('/decrypt', { params: { code, type } }).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  }
}
